import { createTheme, responsiveFontSizes } from "@mui/material";

export let theme = createTheme({
  typography: {
    fontFamily: "Sparkasse, Arial, sans-serif",
  },
  palette: {
    primary: {
      light: "#eceff1",
      main: "#6bb5e4",
      dark: "#607d8b",
    },
    secondary: {
      main: "#5c73fd",
    },
    warning: {
      main: "#d32d7d",
    },
    info: {
      main: "#fafafa",
      dark: "#eceff1",
    },
  },
});

theme = responsiveFontSizes(theme);
